import { Nullable } from "./Nullable";

export interface PlaceDescription {
    code: string;
    fiasGuid: string;
    name: string;
    abbreviation: string;
    isError: boolean;
}

export function isPlaceDescription(value: PlaceDescription | string | null | undefined): value is PlaceDescription {
    return !!value && typeof value === "object";
}

export interface Address {
    region: Nullable<PlaceDescription>;
    district: Nullable<PlaceDescription>;
    city: Nullable<PlaceDescription>;
    settlement: Nullable<PlaceDescription>;
    street: Nullable<PlaceDescription>;
    index: Nullable<string>;
    okato: Nullable<string>;
    house: Nullable<string>;
    building: Nullable<string>;
    room: Nullable<string>;
}

export declare type Place =
    | "region"
    | "district"
    | "city"
    | "settlement"
    | "street"
    | "index"
    | "okato"
    | "house"
    | "building"
    | "room";

export interface VerifyResult {
    address: Address;
    invalidItem: number;
    isKladrAddress: boolean;
}
